var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20205_18608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.75C13.1213 18.75 13.625 18.2463 13.625 17.625C13.625 17.0037 13.1213 16.5 12.5 16.5C11.8787 16.5 11.375 17.0037 11.375 17.625C11.375 18.2463 11.8787 18.75 12.5 18.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6.00001H12.125C11.6815 5.99902 11.2422 6.08564 10.8323 6.2549C10.4224 6.42416 10.0499 6.67272 9.73632 6.98632C9.42272 7.29991 9.17416 7.67236 9.0049 8.08228C8.83564 8.4922 8.74902 8.93152 8.75001 9.37501V9.75001H10.25V9.37501C10.25 8.87773 10.4476 8.40081 10.7992 8.04918C11.1508 7.69755 11.6277 7.50001 12.125 7.50001H13.25C13.7473 7.50001 14.2242 7.69755 14.5758 8.04918C14.9275 8.40081 15.125 8.87773 15.125 9.37501C15.125 9.87229 14.9275 10.3492 14.5758 10.7008C14.2242 11.0525 13.7473 11.25 13.25 11.25H11.75V14.625H13.25V12.75C14.1451 12.75 15.0036 12.3944 15.6365 11.7615C16.2694 11.1286 16.625 10.2701 16.625 9.37501C16.625 8.4799 16.2694 7.62146 15.6365 6.98852C15.0036 6.35559 14.1451 6.00001 13.25 6.00001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20205_18608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9e28aede3856fbe3261995346f4dfd27.svg";
export { ForwardRef as ReactComponent };